module.exports = __webpack_public_path__ + "static/media/Slice32@2x.392915d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice32@2x.png
// module id = 1463
// module chunks = 0